"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactstrap = require("reactstrap");
var _reactDetectClickOutside = require("react-detect-click-outside");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../Icon");
require("./style.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ButtonDropdown = props => {
  const [dropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const {
    bgColor,
    className,
    handleClick,
    dropdownItems,
    primaryText,
    icon,
    isDisabled,
    withoutPadding
  } = props;
  const closeDropdown = () => {
    setDropdownOpen(false);
  };
  const ref = (0, _reactDetectClickOutside.useDetectClickOutside)({
    onTriggered: closeDropdown
  });
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "dropdown",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.ButtonDropdown, {
    disabled: isDisabled,
    toggle: toggle,
    className: `ixn-button--dropdown ${isDisabled ? 'disabled' : ''} ${dropdownOpen ? 'show' : 'hide'} `
  }, /*#__PURE__*/_react.default.createElement(_reactstrap.Button, {
    className: `${className}`,
    disabled: isDisabled,
    id: "caret",
    color: bgColor,
    onClick: event => {
      handleClick(event);
    }
  }, icon, /*#__PURE__*/_react.default.createElement("span", {
    className: "primary--text"
  }, primaryText)), /*#__PURE__*/_react.default.createElement("span", {
    className: "divider--left"
  }), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownToggle, {
    className: `${className}`,
    split: true,
    color: bgColor,
    disabled: isDisabled
  }), /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownMenu, {
    className: `${dropdownOpen ? 'show' : 'hide'}`
  }, dropdownItems.map((val, index) => /*#__PURE__*/_react.default.createElement(_reactstrap.DropdownItem, {
    className: `${withoutPadding ? 'no--padding' : ''}`,
    key: index,
    onClick: event => {
      handleClick(event);
    }
  }, val)))));
};
exports.ButtonDropdown = ButtonDropdown;
ButtonDropdown.defaultProps = {
  bgColor: 'primary',
  className: '',
  /** Contain various classes which apply styling to dropdown */
  handleClick: () => {},
  /** Array to contain dropdown list */
  dropDownItems: [],
  /** Specifies boolean value to show caret or not */
  primaryText: "",
  /** Disables the button if true. */
  isDisabled: false,
  withoutPadding: false,
  icon: /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    icon: ['fas', 'plus']
  })
};
ButtonDropdown.propTypes = {
  /** Specifies the color of button. Defaults to blue shade. */
  bgColor: _propTypes.default.string,
  /** Custom classname applied to default button. */
  className: _propTypes.default.string,
  /** Contain various classes which apply styling to dropdown */
  handleClick: _propTypes.default.func,
  /** Array to contain dropdown list */
  dropDownItems: _propTypes.default.array,
  /** Specifies boolean value to show caret or not */
  primaryText: _propTypes.default.string,
  /** Disables the button if true. */
  isDisabled: _propTypes.default.bool,
  /** Displays icon before the button. Default is '+' icon. */
  icon: _propTypes.default.node
};